import { Component, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  failed: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <main className="fatal-screen">
        <span className="eyebrow">Recuperación de interfaz</span>
        <h1>Esta vista no pudo renderizarse.</h1>
        <p>
          Tus datos permanecen en Supabase. Recarga la aplicación o vuelve al portafolio para
          continuar.
        </p>
        <div className="form-actions">
          <button
            className="button button--secondary"
            type="button"
            onClick={() => location.assign("/")}
          >
            Volver al portafolio
          </button>
          <button
            className="button button--primary"
            type="button"
            onClick={() => location.reload()}
          >
            Recargar aplicación
          </button>
        </div>
      </main>
    );
  }
}
